// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2rZkl","label":"LabeledBox_label__75WwU"};